export enum UserPermissions {
  Admin = 'admin',
  Trainer = 'trainer',
  Sysadmin = 'SYSADMIN',
  ReadValuation = 'read_valuation'
}
